/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';
import React from 'react';
import { FormPage, theme, Title, Message, Content } from 'shared';

export type MainContentProps = Pick<
  FormPage,
  'title' | 'message' | 'design'
> & {
  pageType?: FormPage['pageType'];
  pageId?: FormPage['pageId'];
  children?: React.ReactNode;
};

const { smallAndUp, lessThanSmall } = theme.BREAKPOINTS;

const MessageWrapper = styled.div`
  @media (${smallAndUp}) {
    padding: 0 24px;
  }
  @media (${lessThanSmall}) {
    padding: 0 12px;
  }
`;

export const MainContent = React.forwardRef<HTMLDivElement, MainContentProps>(
  (props, ref) => {
    const { title, message, children, design, pageType, pageId } = props;
    const { titleFont, titleBackground, messageFont, formBackground } =
      design.colors;

    return (
      <Content
        data-cy-page-type={pageType}
        data-cy-page-id={pageId}
        css={{ margin: '0 auto' }}
        backgroundColor={formBackground}
      >
        <div
          ref={ref}
          tabIndex={-1}
          style={{ outline: 0, height: 0, width: 0 }}
        />
        {title && (
          <Title
            color={titleFont}
            backgroundColor={titleBackground}
            title={title}
          />
        )}
        {message && (
          <MessageWrapper css={{ marginTop: '24px' }}>
            <Message
              color={messageFont}
              message={message}
              pageType={pageType}
            />
          </MessageWrapper>
        )}
        {children}
      </Content>
    );
  }
);
